import React, { useState } from "react";
import "./Product.scss";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import axios from "axios";
import FeaturedProducts from "../../components/FeaturedProducts/FeaturedProducts";
import Loading from "../../components/loading/Loading";

const Product = () => {
  const products = useSelector((state) => state.cart.products);
  const { id, slug } = useParams();
    const location = useLocation();
  const [selectImage, setSelectImage] = useState("img");
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState([]);

console.log(slug,id);
 

 useEffect(() => {
   // Only skip if both slug and id are missing
   if (!slug && !id) return;

   const getProduct = async () => {
     try {
       const response = await axios.get("/singal-product", {
         params: { slug, id },
       });
       setProduct(response.data);

       // ✅ set first photo as default
       if (response.data?.proPhotos?.length > 0) {
         setSelectImage(response.data.proPhotos[0]);
       }
     } catch (error) {
       console.error(error);
     }
   };

   getProduct();
 }, [slug, id]);

  const getQuantityInCart = () => {
    const cartItem = products.find((item) => item.id);
    return cartItem
      ? {
          id: cartItem.id,
          max_order_value: cartItem.max_order_qut,
          quantity: cartItem.quantity,
        }
      : { id: null, max_order_value: 2, quantity: 2 }; // Default values for quantity if no item is found
  };

  const cartData = getQuantityInCart();

  const flashSaleItemsInCart = products.filter(
    (product) => product.flash_sale === true
  ).length;

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="product">
          {loading ? (
            <Loading />
          ) : (
            <div className="product_card">
              <div className="left">
                {/* Thumbnails */}
                <div className="images">
                  {product?.proPhotos?.map((photo, index) => (
                    <img
                      key={index}
                      src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${photo}`}
                      alt={`Product ${index + 1}`}
                      onClick={() => setSelectImage(photo)}
                    />
                  ))}
                </div>

                {/* Main Image */}
                <div className="mainImg">
                  <img
                    src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${
                      selectImage || product?.proPhoto?.[0]
                    }`}
                    alt="Selected Product"
                  />
                </div>
              </div>

              <div className="right">
                <div>
                  <span
                    style={{
                      backgroundColor: "#53dc1f",
                      padding: "5px 20px",
                      color: "white",
                      fontSize: "18px",
                      borderRadius: "5px",
                    }}
                  >
                    {product.discount}% Off
                  </span>
                </div>
                <h2>{product?.name}</h2>
                {/* <p>{data?.id}</p> */}
                <span className="price">
                  {" "}
                  <em>AED </em>
                  {product.price}
                </span>
                <h5>Weight - {product.weight}</h5>
                <p>{product.description}</p>

                <div className="quantity">
                  <button
                    onClick={() =>
                      setQuantity((prev) => (prev === 1 ? 1 : prev - 1))
                    }
                  >
                    -
                  </button>

                  {quantity}

                  <button
                    onClick={() => {
                      if (quantity < product.stock) {
                        setQuantity((prev) => prev + 1);
                      } else {
                        toast.warning(`Only ${product.stock} pcs available`);
                      }
                    }}
                  >
                    +
                  </button>
                </div>

                {cartData.id === product?.id &&
                cartData.max_order_value === 2 &&
                product?.max_order_qut === 2 &&
                cartData.quantity >= 2 ? (
                  <div>
                    <div className="add">
                      <AddShoppingCartIcon />
                      ADD TO CART
                    </div>
                  </div>
                ) : (
                  <div
                    className="add"
                    onClick={() => {
                      if (product?.outofstock || product.stock === 0) {
                        toast.error("Temporary out of stock");
                      } else if (
                        product?.flash_sale &&
                        flashSaleItemsInCart >= product.flash_sale_product_pcs
                      ) {
                        toast.error(
                          "You can only add up to 3 flash sale items to the cart"
                        );
                      } else if (quantity > product.stock) {
                        toast.error(
                          `Only ${product.stock} pcs available in stock`
                        );
                      } else {
                        dispatch(
                          addToCart({
                            id: product.id,
                            name: product.name,
                            desc: product.description,
                            weight: product.weight,
                            price: product.price,
                            stock: product.stock,
                            img: product.proPhotos[0],
                            quantity,
                          })
                        );
                        toast.success("Product added to cart!");
                      }
                    }}
                  >
                    <AddShoppingCartIcon />
                    ADD TO CART
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="cont_wrp">
          <FeaturedProducts type="featured" />
        </div>
      </div>
    </div>
  );
};

export default Product;
